import {Injectable} from '@angular/core';
import {Subject, takeUntil} from 'rxjs';
import {selectAllowedToCreateOffer} from '../../store/auth/selectors/auth.selectors';
import {Store} from '@ngrx/store';
import {AuthState} from '../../store/auth/reducers/auth.reducer';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {
  protected destroy$ = new Subject<void>();
  private allowedToCreateOffer: boolean;

  constructor(private readonly authStateStore: Store<AuthState>) {
    this.authStateStore.select(selectAllowedToCreateOffer).pipe(takeUntil(this.destroy$))
      .subscribe(
        value => this.allowedToCreateOffer = value
      );
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  canCreateOfferForProposal(coverage: number, deadline: any) {
    const deadlinePlus24Hours = new Date(new Date(deadline).getTime() + 60 * 60 * 24 * 1000);
    return new Date() <= deadlinePlus24Hours && this.allowedToCreateOffer && coverage < 1;
  }


}
